import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { RecipientDetailsResponse } from '@state/types/RecipientDetailsResponse';
import { AppointmentHeaderResponse } from '@state/types/AppointmentHeaderResponse';

export const appointmentV2Api = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: 'secured/v2/appointment' }),
  reducerPath: 'appointment-v2-api',
  tagTypes: ['APPOINTMENT_V2'],
  endpoints: (build) => ({
    fetchRecipientDetails: build.query<
      RecipientDetailsResponse,
      { appointmentId: number }
    >({
      query: ({ appointmentId }) => ({
        url: `/${appointmentId}/recipient-details`,
        method: 'GET'
      }),
      providesTags: (_res, _err, { appointmentId }) => [
        { type: 'APPOINTMENT_V2', id: `recipient-details-${appointmentId}` }
      ]
    }),
    fetchAppointmentHeader: build.query<
      AppointmentHeaderResponse,
      { appointmentId: number }
    >({
      query: ({ appointmentId }) => ({
        url: `/${appointmentId}`,
        method: 'GET'
      }),
      providesTags: (_res, _err, { appointmentId }) => [
        { type: 'APPOINTMENT_V2', id: `header-${appointmentId}` }
      ]
    })
  })
});

export const { useFetchRecipientDetailsQuery, useFetchAppointmentHeaderQuery } =
  appointmentV2Api;

export type StateWithAppointmentV2Api = {
  [appointmentV2Api.reducerPath]: ReturnType<typeof appointmentV2Api.reducer>;
};
